import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncBatchThreadOperationsToolbarContainerError from './AsyncBatchThreadOperationsToolbarContainerError';
import EmptyComponent from './EmptyComponent';
const AsyncBatchThreadOperationsToolbarContainer = Loadable({
  loader: () => import( /* webpackChunkName: "batch-thread-operations-container" */'../../batch-thread-operations-toolbar/containers/BatchThreadOperationsToolbarContainer'),
  LoadingComponent: EmptyComponent,
  ErrorComponent: AsyncBatchThreadOperationsToolbarContainerError
});
export default AsyncBatchThreadOperationsToolbarContainer;